import { createPulseTracker, Tracker } from '@schibsted/pulse-sdk';

import { config } from '../../../config';
import { consentManager } from '../../privacy';
import { getActorObject } from '../pulseActor';

import { syncPageViewId, exposePulseInstanceAsGlobal } from './helpers';
import { createExperimentsBuilder } from './builders';

import type { EventInput } from '@schibsted/pulse-sdk';

const trackerPromise = config.enableTracking
  ? createPulseTracker({
      clientId: config.pulse.clientId,
      config: {
        useBeaconWhenAvailable: true,
        consents: consentManager.getCachedOrDefaultConsentsForPulse(),
        requireAdvertisingOptIn: consentManager.type !== 'fallback',
        deployStage: config.env === 'production' ? 'pro' : 'dev',
        deployStageTpaas: config.env === 'production' ? 'pre' : 'dev',
      },
    })
  : Promise.resolve(undefined);

trackerPromise
  .then((tracker) => {
    if (tracker) {
      tracker.update({
        actor: getActorObject(config.provider, config.pulse.actorRealm),
        experiments: createExperimentsBuilder(),
      });
      syncPageViewId(tracker);
      consentManager.subscribeTrackerToConsents(tracker);
      exposePulseInstanceAsGlobal(tracker, Tracker);
    }
    return;
  })
  .catch((err) => {
    console.error(err);
  });

export const getTracker = () => trackerPromise;

export const pulseTrackPageView = async (event: EventInput) => {
  try {
    const tracker = await getTracker();
    await tracker?.trackPageView(event);
  } catch (err) {
    console.error(err);
  }
};

export const pulseTrackEvent = async (
  eventType: 'engagementEvent' | 'trackerEvent',
  event: EventInput
) => {
  try {
    const tracker = await getTracker();
    await tracker?.track(eventType, event);
  } catch (err) {
    console.error(err);
  }
};
